/**
 * Reading structure out of the editable wording.
 *
 * The wording editor edits plain bullets, so a few sections carry their
 * structure in the text itself: a question and its answer, a heading and its
 * detail, a quotation and who said it. These split it back out, and fall back
 * to the whole bullet when somebody wrote it another way, so an unexpected
 * shape reads as a plain line rather than disappearing.
 */

/** "Is a deposit required? No." → question and answer. */
export function splitQuestion(text: string): {
  question: string
  answer: string | null
} {
  const index = text.indexOf('?')
  if (index === -1 || index === text.length - 1) {
    return { question: text, answer: null }
  }
  return {
    question: text.slice(0, index + 1).trim(),
    answer: text.slice(index + 1).trim(),
  }
}

/**
 * "Removing dead branches. This is the work that…" → "Removing dead
 * branches.": what something is, without the why. A passage of one sentence
 * comes back whole.
 */
export function firstSentence(text: string): string {
  const trimmed = text.trim()
  const match = /^.*?[.!?](?=\s)/s.exec(trimmed)
  return match === null ? trimmed : match[0]
}

/** "No deposit — Nothing to pay up front." → heading and detail. */
export function splitHeading(text: string): {
  heading: string
  detail: string | null
} {
  const match = /^(.+?)\s+[—–-]\s+(.+)$/.exec(text)
  if (match?.[1] === undefined || match[2] === undefined) {
    return { heading: text, detail: null }
  }
  return { heading: match[1].trim(), detail: match[2].trim() }
}

/**
 * "They cleaned up before they left. — Steve P. · Google" → quotation and
 * attribution. Split at the LAST dash, because a quotation can contain one.
 */
export function splitReview(text: string): {
  quote: string
  attribution: string | null
} {
  const match = /^(.*\S)\s+[—–]\s+([^—–]+)$/.exec(text)
  if (match?.[1] === undefined || match[2] === undefined) {
    return { quote: text, attribution: null }
  }
  return { quote: match[1].trim(), attribution: match[2].trim() }
}
